import { Paper, Typography, Box } from '@mui/material';
import PublicLegalLayout from '../../components/legal/PublicLegalLayout';
import { PLATFORM_PRIVACY_MARKDOWN } from '../../constants/platformLegal';

function renderContent(content: string) {
  const blocks = content.split(/\n\n+/);
  return (
    <Box sx={{ lineHeight: 1.7 }}>
      {blocks.map((block, i) => {
        const trimmed = block.trim();
        if (!trimmed) return null;
        if (trimmed.startsWith('# ')) {
          return (
            <Typography key={i} variant="h5" fontWeight={800} sx={{ mt: i ? 2.5 : 0, mb: 1 }}>
              {trimmed.slice(2)}
            </Typography>
          );
        }
        if (trimmed.startsWith('## ')) {
          return (
            <Typography key={i} variant="h6" fontWeight={800} sx={{ mt: i ? 2 : 0, mb: 1 }}>
              {trimmed.slice(3)}
            </Typography>
          );
        }
        if (trimmed.startsWith('- ')) {
          return (
            <Box key={i} component="ul" sx={{ pl: 2.5, my: 1 }}>
              {trimmed.split('\n').map((line, j) => (
                <Typography key={j} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  {line.replace(/^- /, '')}
                </Typography>
              ))}
            </Box>
          );
        }
        return (
          <Typography key={i} variant="body2" color="text.secondary" sx={{ mb: 1.25, whiteSpace: 'pre-wrap' }}>
            {trimmed}
          </Typography>
        );
      })}
    </Box>
  );
}

/** Play Store privacy page — always uses shipped copy (never overwritten by stale API/DB settings). */
export default function PrivacyPolicyPage() {
  return (
    <PublicLegalLayout
      title="Privacy Policy"
      subtitle="This Privacy Policy applies to everyone who uses TaxiAppz Pro Plus mobile apps and related services — customers, drivers, delivery partners, service providers, and vendors."
    >
      <Paper elevation={0} sx={{ p: { xs: 2.5, md: 3.5 }, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="caption" color="text.disabled" display="block" sx={{ mb: 2 }}>
          Last updated: 2026-08-08
        </Typography>
        {renderContent(PLATFORM_PRIVACY_MARKDOWN)}
      </Paper>
    </PublicLegalLayout>
  );
}
